import React, { useState, useEffect } from "react";
import "../Users/users.css";
import "./payments.css";
import DataSection from "../../components/DataSection";
import QrCodePayment from "../../../assets/qr_code_pagamento.png";
import {
  listPayments,
  createPayment,
  deletePayment,
  updatePayment,
} from "../../../services/api/payments";
import { listUsers } from "../../../services/api/users";
import {
  listRealEstates,
  createRealEstate,
  deleteRealEstate,
} from "../../../services/api/real_estates";
import { decodeJWT } from "../../../utils/getUserByToken";
import { Dropdown } from "semantic-ui-react";
import { getUserById } from "../../../services/api/users";
import { FaUserEdit, FaTrashAlt } from "react-icons/fa";
import Spinner from "../../components/Spinner";

const PAYMENT_STATUS_OPTIONS = [
  { value: "paid", label: "Pago" },
  { value: "pending", label: "Pendente" },
  { value: "warning", label: "Atenção" },
];

export default function Payments() {
  const [currentUser, setCurrentUser] = useState({ nome: "", nivel: null });
  const [pagamentos, setPagamentos] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  const initialNovoPagamentoState = {
    payer_name: "",
    status: "pending",
    paid_at: "",
    day: "",
  };
  const [novoPagamento, setNovoPagamento] = useState(initialNovoPagamentoState);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [payers, setPayers] = useState([]);

  const pixCode = "luizatabelas2@gmail.com";

  const dayOptions = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return { key: day, value: day, text: String(day) };
  });

  const statusOptions = PAYMENT_STATUS_OPTIONS.map((option) => ({
    key: option.value,
    value: option.value,
    text: option.label,
  }));

  const [paymentStatus, setPaymentStatus] = useState();

  const fetchPagamentosRobust = async () => {
    try {
      const response = await listPayments();
      if (response && Array.isArray(response)) {
        setPagamentos(response);
      } else {
        setPagamentos([]);
      }
    } catch (err) {
      console.error("Erro ao buscar pagamentos:", err);
      setPagamentos([]);
    }
  };

  async function fetchPayersData() {
    try {
      const usersResponse = await listUsers();
      const realEstatesResponse = await listRealEstates();
      const userPayersList =
        usersResponse && Array.isArray(usersResponse) ? usersResponse : [];
      const realEstatePayersList =
        realEstatesResponse && Array.isArray(realEstatesResponse)
          ? realEstatesResponse
          : [];
      const allPayersData = [
        ...userPayersList.map((payer) => ({
          id: String(payer.id),
          name: payer.full_name,
          type: "user",
        })),
        ...realEstatePayersList.map((payer) => ({
          id: String(payer.id),
          name: payer.full_name,
          type: "real_estate",
        })),
      ];
      setPayers(allPayersData);
    } catch (error) {
      console.error("Erro ao buscar lista de pagadores:", error);
      setPayers([]);
    }
  }

  async function getUserPaymentStatus(userId) {
    const response = await getUserById(userId);
    setPaymentStatus(response.current_month_payment_status);
  }

  function translatePaymentStatus(paymentStatus) {
    switch (paymentStatus) {
      case "paid":
        return "PAGO";
      case "pending":
      default:
        return "NÃO INFORMADO";
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (token) {
        const decoded = decodeJWT(token);
        setCurrentUser({
          nome: localStorage.getItem("nome") || decoded.sub || "Usuário",
          nivel: decoded.position,
        });
        if (decoded.position === "admin") {
          await Promise.all([fetchPayersData(), fetchPagamentosRobust()]);
        } else {
          await getUserPaymentStatus(decoded.sub);
        }
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const renderStatusPill = (status) => {
    const statusInfo = PAYMENT_STATUS_OPTIONS.find(
      (opt) => opt.value === status
    ) || {
      value: "pending",
      label: "Pendente",
    };
    const statusClass = `status-${statusInfo.value}`;
    return (
      <span className={`status-pill ${statusClass}`}>
        {statusInfo.label.toUpperCase()}
      </span>
    );
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    return day;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleOpenEditModal = (payment) => {
    const day = payment.paid_at ? new Date(payment.paid_at).getUTCDate() : "";
    setSelectedPayment({
      ...payment,
      value: String(payment.value || ""),
      payer_id: String(payment.payer_id || ""),
      description: payment.description || "",
      status: payment.status || "pending",
      paid_at: formatDateForInput(payment.paid_at),
      day: day ? String(day) : "",
    });
    setEditModalOpen(true);
  };

  const handleOpenDeleteModal = (payment) => {
    setSelectedPayment(payment);
    setDeleteModalOpen(true);
  };

  const handleConfirmEdit = async () => {
    if (!selectedPayment || selectedPayment.id == null)
      return alert("Nenhum pagamento selecionado.");
    if (!selectedPayment.payer_id || isNaN(parseInt(selectedPayment.payer_id)))
      return alert("Pagador inválido.");
    try {
      const dataToUpdate = {
        value: parseFloat(selectedPayment.value) || 0,
        description: selectedPayment.description,
        payer_type: selectedPayment.payer_type,
        payer_id: parseInt(selectedPayment.payer_id),
        status: selectedPayment.status,
      };

      if (selectedPayment.day) {
        const year = 2025;
        const month = 1; // January
        const day = parseInt(selectedPayment.day, 10);
        dataToUpdate.paid_at = new Date(
          Date.UTC(year, month - 1, day)
        ).toISOString();
      } else {
        dataToUpdate.paid_at = null;
      }
      await updatePayment(String(selectedPayment.id), dataToUpdate);
      fetchPagamentosRobust();
      setEditModalOpen(false);
      setSelectedPayment(null);
    } catch (error) {
      console.error("Erro ao editar pagamento:", error);
      alert("Falha ao atualizar.");
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedPayment || selectedPayment.id == null) return;
    try {
      // Deleta o pagamento primeiro para remover a dependência
      await deletePayment(String(selectedPayment.id));

      // Se o pagador for do tipo 'real_estate', deleta a entidade correspondente
      if (
        selectedPayment.payer_type === "real_estate" &&
        selectedPayment.payer_id
      ) {
        await deleteRealEstate(String(selectedPayment.payer_id));
      }

      setPagamentos((prev) =>
        prev.filter((p) => String(p.id) !== String(selectedPayment.id))
      );
      setDeleteModalOpen(false);
      setSelectedPayment(null);
    } catch (error) {
      console.error("Erro ao deletar:", error);
      alert(
        "Falha ao excluir. A entidade pagadora pode estar vinculada a outros registros."
      );
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pixCode);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);
    } catch (error) {
      console.error("Erro ao copiar:", error);
    }
  };

  const handleCreatePayment = async () => {
    if (!novoPagamento.payer_name || novoPagamento.payer_name.trim() === "") {
      return alert("Insira o nome do pagador.");
    }
    if (!novoPagamento.status) return alert("Selecione um Status.");
    if (!novoPagamento.day) return alert("Selecione o dia do pagamento.");

    try {
      // 1. Criar a imobiliária com a flag is_payer
      const realEstateData = {
        name: novoPagamento.payer_name,
        is_payer: true,
      };
      const newRealEstate = await createRealEstate(realEstateData);

      if (!newRealEstate || !newRealEstate.id) {
        throw new Error("Falha ao criar a imobiliária para o pagamento.");
      }

      // 2. Criar o pagamento com os dados da nova imobiliária
      const paymentDataToSend = {
        value: 100.0, // Valor fixo ou pode ser ajustado conforme necessário
        description: `Pagamento para ${novoPagamento.payer_name}`,
        payer_type: "real_estate",
        payer_id: newRealEstate.id,
        status: novoPagamento.status,
      };

      if (novoPagamento.day) {
        const year = 2025;
        const month = 1; // January
        const day = parseInt(novoPagamento.day, 10);
        paymentDataToSend.paid_at = new Date(
          Date.UTC(year, month - 1, day)
        ).toISOString();
      } else {
        paymentDataToSend.paid_at = null;
      }

      await createPayment(paymentDataToSend);
      fetchPagamentosRobust();
      setModalIsOpen(false);
      setNovoPagamento(initialNovoPagamentoState);
    } catch (err) {
      console.error("Erro ao criar pagamento:", err);
      alert("Falha ao criar pagamento. Verifique o console para mais detalhes.");
    }
  };

  const handleSimpleInputChange = (
    event,
    setStateFunction,
    currentPaymentState
  ) => {
    const { name, value } = event.target;
    setStateFunction({ ...currentPaymentState, [name]: value });
  };

  const handlePayerTypeChange = (
    event,
    setStateFunction,
    isEditMode = false
  ) => {
    const payerType = event.target.value;
    const stateUpdater = isEditMode ? setSelectedPayment : setNovoPagamento;
    stateUpdater((prev) => ({ ...prev, payer_type: payerType, payer_id: "" }));
  };

  const handlePayerDropdownChange = (e, { value }, isEditMode = false) => {
    const stateUpdater = isEditMode ? setSelectedPayment : setNovoPagamento;
    stateUpdater((prevState) => ({ ...prevState, payer_id: value }));
  };

  const getPayerOptions = (payerType) => {
    if (!payerType) return [];
    return payers
      .filter((p) => p.type === payerType)
      .map((p) => ({
        key: `${p.type}-${p.id}`,
        value: p.id,
        text: p.name || `ID: ${p.id}`,
      }));
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <h1 className="title">PAGAMENTOS</h1>
      {currentUser.nivel === "admin" ? (
        <section className="controll-users">
          <div className="table-controllers">
            <button
              onClick={() => {
                setNovoPagamento(initialNovoPagamentoState);
                setModalIsOpen(true);
              }}
              className="bt-add-new"
            >
              Inserir Pagamento
            </button>
          </div>
          <div className="table-wrapper">
            <table className="table-users">
              <thead>
                <tr>
                  <th>Dia de pagamento</th>
                  <th>Cliente</th>
                  <th>Status</th>
                  <th>Opções</th>
                </tr>
              </thead>
              <tbody>
                {(pagamentos || [])
                  .sort((a, b) => {
                    if (!a.paid_at) return 1;
                    if (!b.paid_at) return -1;
                    return new Date(b.paid_at) - new Date(a.paid_at);
                  })
                  .map((pagamento) => (
                    <tr key={pagamento.id}>
                      <td data-label="Data">
                        {pagamento.paid_at
                          ? formatDisplayDate(pagamento.paid_at)
                          : "N/A"}
                      </td>
                      <td data-label="Cliente">
                        {(pagamento.payer_name || `ID: ${pagamento.payer_id}`).toUpperCase()}
                      </td>
                      <td data-label="Status">
                        {renderStatusPill(pagamento.status)}
                      </td>
                      <td data-label="Opções">
                        <div className="action-buttons">
                          <button
                            onClick={() => handleOpenEditModal(pagamento)}
                            className="edit-button"
                            title="Editar"
                          >
                            <FaUserEdit />
                          </button>
                          <button
                            onClick={() => handleOpenDeleteModal(pagamento)}
                            className="delete-button"
                            title="Deletar"
                          >
                            <FaTrashAlt />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </section>
      ) : (
        <div className="container-payments">
          <DataSection>
            <div className="container-data-payments">
              <div className="container-steps">
                <h2>Como realizar os pagamentos?</h2>
                <p>
                  <span>Passo 1: </span>Abra o aplicativo do seu banco ou
                  instituição financeira.
                </p>
                <p>
                  <span>Passo 2: </span>Escaneie o QR Code ou copie o código
                  abaixo para realizar o pagamento.
                </p>
                <p>
                  <span>Passo 3: </span>Após o pagamento, envie o comprovante
                  para{" "}
                  <a
                    href="https://api.whatsapp.com/send?phone=5513996025791"
                    target="_blank"
                    rel="noreferrer"
                  >
                    &#40;13&#41; 99602-5791
                  </a>
                  .
                </p>
              </div>
              <div className="data-payments">
                <img src={QrCodePayment} alt="QR Code Pix" />
                <p>
                  VALOR DO PAGAMENTO: <span>R$ 100,00</span>
                </p>
                <p className="pix-code">
                  <span>Código Pix: </span>
                  {pixCode}
                </p>
                <button
                  onClick={handleCopy}
                  className={`copy-button ${isCopied ? "copied" : ""}`}
                >
                  {isCopied ? "CÓDIGO PIX COPIADO!" : "COPIAR CÓDIGO"}
                </button>
              </div>
            </div>
          </DataSection>
        </div>
      )}

      {modalIsOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Novo Pagamento</h2>
            <input
              type="text"
              name="payer_name"
              placeholder="Insira o nome do pagador"
              value={novoPagamento.payer_name}
              onChange={(e) =>
                handleSimpleInputChange(e, setNovoPagamento, novoPagamento)
              }
            />
            <label htmlFor="day_create">Dia do Pagamento:</label>
            <Dropdown
              id="day_create"
              placeholder="Selecione o dia"
              fluid
              search
              selection
              options={dayOptions}
              value={novoPagamento.day}
              onChange={(e, { value }) =>
                setNovoPagamento((prev) => ({ ...prev, day: value }))
              }
            />
            <Dropdown
              name="status"
              placeholder="Selecione o Status"
              fluid
              selection
              options={statusOptions}
              value={novoPagamento.status}
              onChange={(e, { name, value }) =>
                setNovoPagamento((prev) => ({ ...prev, [name]: value }))
              }
            />
            <div className="modal-buttons">
              <button onClick={handleCreatePayment}>Confirmar</button>
              <button
                onClick={() => setModalIsOpen(false)}
                className="cancel-button"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {editModalOpen && selectedPayment && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Editar Pagamento</h2>
            <label htmlFor="day_edit">Dia do Pagamento:</label>
            <Dropdown
              id="day_edit"
              placeholder="Selecione o dia"
              fluid
              search
              selection
              options={dayOptions}
              value={selectedPayment.day}
              onChange={(e, { value }) =>
                setSelectedPayment((prev) => ({ ...prev, day: value }))
              }
            />
            <label htmlFor="status_edit">Status do pagamento</label>
            <Dropdown
              id="status_edit"
              name="status"
              placeholder="Selecione o Status"
              fluid
              selection
              options={statusOptions}
              value={selectedPayment.status}
              onChange={(e, { name, value }) =>
                setSelectedPayment((prev) => ({ ...prev, [name]: value }))
              }
            />
            <div className="modal-buttons">
              <button onClick={handleConfirmEdit}>Salvar</button>
              <button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedPayment(null);
                }}
                className="cancel-button"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && selectedPayment && (
        <div className="modal-overlay">
          <div className="modal delete-modal">
            <h2>Confirmação</h2>
            <p>Tem certeza que deseja deletar esse pagamento?</p>
            <div className="modal-buttons">
              <button onClick={handleConfirmDelete} className="delete-button">
                Confirmar
              </button>
              <button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedPayment(null);
                }}
                className="cancel-button"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}